import React, { memo, useEffect } from 'react';
import { Snackbar, Button, useTheme, Theme } from '@quillbot/design-system';
import { makeStyles } from '@quillbot/design-system';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from 'src/_common/models/redux/store';
import { toggleToastrAction } from 'src/_common/actions/commonActions';
import { getToastrAction } from '@Common/handlers/services';

const useStyles = makeStyles({
  snackbarBottomLeft: {
    bottom: '65px',
    left: '65px',
  },
});

function Toast() {
  const dispatch = useDispatch();
  const theme = useTheme<Theme>();
  const handleActionClick = (): void => {
    const toastrActionObj = getToastrAction();
    if (toastrActionObj) {
      toastrActionObj.action();
      dispatch(toggleToastrAction('', 0, false));
    }
  };
  const toastrAction =
    getToastrAction !== null ? (
      <Button
        size="small"
        style={{ color: theme.specialColors.TOAST_COLOR }}
        onClick={handleActionClick}
      >
        <span>{getToastrAction()?.actionText}</span>
      </Button>
    ) : null;

  const toastrState = useSelector((state: RootState) => state.common.quillToast);
  const classes = useStyles();

  useEffect(() => {
    if (toastrState.isShown) {
      setTimeout(
        () => dispatch(toggleToastrAction('', 0, false, toastrState.position)),
        toastrState.timeout
      );
    }
  });
  return (
    <Snackbar
      open={toastrState.isShown}
      classes={{
        anchorOriginBottomLeft: classes.snackbarBottomLeft,
        anchorOriginBottomRight: classes.snackbarBottomLeft,
      }}
      anchorOrigin={toastrState.position}
      autoHideDuration={toastrState.timeout}
      action={toastrAction}
      message={toastrState.message}
    />
  );
}
export default memo(Toast);
